module.exports = __webpack_public_path__ + "img/success_icon01.82c10be9.png";